import {createSlice} from "redux-starter-kit";

const updateCurrentPageLength = (state, action) =>{
    const currentPageLength = action.payload
    return {...state, currentPageLength}
}



const tableDuck = createSlice(
    {slice: 'table',
        initialState: {
        currentPageLength: 10
        }, reducers: {updateCurrentPageLength}
    }

)

export default tableDuck



// WEBPACK FOOTER //
// ./src/redux/tableDuck.js